import { get, sync, call } from 'vuex-pathify'
import SvgCompassLoader from '@/components/svg/CompassLoader'
import Input from '@/components/Input'
import PlaceList from '@/components/PlaceList'
import Estimate from '@/components/Estimate'
import CurrentLocation from '@/components/CurrentLocation'
import AirportItem from '@/components/AirportItem'

export default {
  components: { SvgCompassLoader, Input, PlaceList, Estimate, CurrentLocation, AirportItem },
  props: {
    estimateLoading: { type: Boolean, default: false },
  },
  data () {
    return {
      focusedInput: null,
    }
  },
  computed: {
    ...get('explorer/', ['userLocation', 'estimate']),
    ...sync('explorer/', ['places', 'suggestedAirports', 'order', 'fromAirport', 'toAirport']),
  },
  methods: {
    ...call('explorer/', ['fetchPlaces']),
    handleCurrentLocation (e) {

    },
    inputHandler (field, val) {
      if (!val) {
        this.places = []
        this.suggestedAirports = []
        this.order = []
        return
      }
      if (this[field + 'Airport']) this[field + 'Airport'] = null
      this.fetchPlaces(val)
    },
  }
}
